import { ITasksFilter } from '../../../../task-manager.interfaces';


const filterData = (value: any[] = []) =>
  Object.entries(value).flatMap(([key, value]) => (value ? [key] : []));

const getInitialCheckList = (items: string[] = []) =>
  items.reduce((init: { [key: string]: boolean }, curr: string) => ({ ...init, [curr]: true }), {});

export const getInitialFilterData = (filter: ITasksFilter) => ({
  types: getInitialCheckList(filter?.types),
  statuses: getInitialCheckList(filter?.statuses),
  overdue: getInitialCheckList(filter?.overdue),

});

export const getFilteredData = (values: ITasksFilter) => ({
  types: filterData(values?.types),
  statuses: filterData(values?.statuses),
  overdue: filterData(values?.overdue),
});
